import { validateCriteria } from '../../../utils/CriteriaHelpers';
import { validateCriteriaConfiguration } from '../../../components/Criteria/CriteriaPanel/validation';

const validate = (values) => {
  if (!values || !values.offer) return;
  const errors = {
    offer: {},
  };

  if (!values.offer.name || values.offer.name === '') {
    errors.offer.name = 'Name is required.';
  }

  // ZET-4257: with the unified criteria panel the configuration JSON replaces the legacy offer
  // criteria fields, so validate one or the other — never both.
  const criteriaConfiguration = values?.criteria?.criteriaConfiguration;

  if (criteriaConfiguration) {
    const criteriaConfigValidation = validateCriteriaConfiguration(criteriaConfiguration);
    if (criteriaConfigValidation.hasErrors) {
      errors.criteria = criteriaConfigValidation.summary || 'Criteria contains validation errors.';
    }
  } else {
    errors.offer = { ...errors.offer, ...validateCriteria(values.offer) };
  }

  return errors;
};

export default validate;
